import { SerialDescriptorForNullable2slcv65za9oog as SerialDescriptorForNullable } from '../internal/NullableSerializer.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from './SerialDescriptor.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.c1p(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.r1m();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor()) {
    tmp = _this__u8e3s4.l1p_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable()) {
      tmp = get_capturedKClass(_this__u8e3s4.h1p_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
var ContextDescriptorClass;
function ContextDescriptor() {
  if (ContextDescriptorClass === VOID) {
    class $ {
      constructor(original, kClass) {
        this.k1p_1 = original;
        this.l1p_1 = kClass;
        this.m1p_1 = this.k1p_1.u1n() + '<' + this.l1p_1.j1() + '>';
      }
      u1n() {
        return this.m1p_1;
      }
      equals(other) {
        var tmp0_elvis_lhs = other instanceof ContextDescriptor() ? other : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var another = tmp;
        return equals(this.k1p_1, another.k1p_1) && another.l1p_1.equals(this.l1p_1);
      }
      hashCode() {
        var result = this.l1p_1.hashCode();
        result = imul(31, result) + getStringHashCode(this.m1p_1) | 0;
        return result;
      }
      toString() {
        return 'ContextDescriptor(kClass: ' + toString(this.l1p_1) + ', original: ' + toString(this.k1p_1) + ')';
      }
      n1p() {
        return this.k1p_1.n1p();
      }
      g1p() {
        return this.k1p_1.g1p();
      }
      o1p() {
        return this.k1p_1.o1p();
      }
      p1p() {
        return this.k1p_1.p1p();
      }
      q1p() {
        return this.k1p_1.q1p();
      }
      r1p(index) {
        return this.k1p_1.r1p(index);
      }
      s1p(name) {
        return this.k1p_1.s1p(name);
      }
      t1p(index) {
        return this.k1p_1.t1p(index);
      }
      u1p(index) {
        return this.k1p_1.u1p(index);
      }
      v1p(index) {
        return this.k1p_1.v1p(index);
      }
    }
    initMetadataForClass($, 'ContextDescriptor', VOID, VOID, [SerialDescriptor()]);
    ContextDescriptorClass = $;
  }
  return ContextDescriptorClass;
}
function withContext(_this__u8e3s4, context) {
  return new (ContextDescriptor())(_this__u8e3s4, context);
}
//region block: exports
export {
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  withContext as withContext3ge61vpog00ae,
};
//endregion

//# sourceMappingURL=ContextAware.mjs.map
